import { useReducer } from 'react';
import labelsStore, { INITAL_LABEL } from 'src/store/labels/labelsStore';
import { Language } from 'src/store/language/languageStore.types';
import { getLabels } from '../services/getLabels';
import {
  LabelsStoreKind,
  LabelsStoreType,
} from '../store/labels/labelsStore.types';

export interface LabelsHook {
  state: LabelsStoreType;
  actions: { initializeLabels: (language: Language) => void };
}

const useLabelsHook = (): LabelsHook => {
  const [state, dispatch] = useReducer(labelsStore, INITAL_LABEL);
  const initializeLabels: (
    language: Language
  ) => Promise<void> = async language => {
    const data = await getLabels(language);
    dispatch({
      type: LabelsStoreKind.INITIAL,
      payload: data,
    });
  };
  return { state, actions: { initializeLabels } };
};

export default useLabelsHook;
